var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_386_8791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4067 6.35079H11.3882L10.5841 5.99983L9.78004 5.64887H10.7482C11.1017 5.64887 11.3882 5.36233 11.3882 5.00887V3.93848C11.3882 1.7231 9.58311 -0.0820312 7.36773 -0.0820312C5.15234 -0.0820312 3.34721 1.7231 3.34721 3.93848V4.99695C3.34721 5.35041 3.63375 5.63695 3.98721 5.63695H4.95542L3.34721 6.35079H1.34516C1.13183 6.35079 0.951316 6.5313 0.951316 6.76105V9.5672C0.934906 13.1282 3.82311 16 7.36773 16C10.9288 16 13.8005 13.1282 13.8005 9.5672V6.76105C13.8005 6.5313 13.62 6.35079 13.4067 6.35079ZM7.36773 12.078C6.69491 12.078 5.80055 11.52 5.80055 10.3713C5.80055 9.69848 6.21307 8.87797 7.40055 8.87797C8.53044 8.87797 9.00055 9.71489 9.00055 10.3713C9.00055 11.52 8.04055 12.078 7.36773 12.078ZM4.95542 6.35079H3.34721L4.95542 5.63695V3.93848C4.95542 2.60925 6.0385 1.52617 7.36773 1.52617C8.69696 1.52617 9.78004 2.60925 9.78004 3.93848V5.64887L10.5841 5.99983L11.3882 6.35079H9.78004H4.95542Z",
    fill: "#7D7D7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_386_8791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.44,
    height: 16,
    fill: "white",
    transform: "translate(0.679688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyLock);
export default __webpack_public_path__ + "static/media/key-lock.eaf1a2834e91d23bf057044c329a2377.svg";
export { ForwardRef as ReactComponent };